<template>
  <div
    class="top ani animated"
    s-a-effect="fadeInUp"
    s-a-duration="1s"
    s-a-delay="0.2s"
    s-a-style-cache=" "
    style="
      width: 100%;
      display: flex;
      visibility: visible;
      animation-name: fadeInUp;
      -webkit-animation-name: fadeInUp;
      animation-duration: 1s;
      -webkit-animation-duration: 1s;
      animation-delay: 0.2s;
      -webkit-animation-delay: 0.2s;
      justify-content: space-between;
    "
  >
    <img class="logo" src="../assets/img/logo2.png" alt="" />
    <!-- <img
      class="markUp"
      src="../assets/img/markUp.png"
      alt=""
      @click="state.showBox = true"
    /> -->

    <!-- <ul class="coverBox disn" id="ll" v-if="state.showBox">
      <li>@日浩集团</li>

      <li>薪酬福利</li>

      <li>校园招聘</li>

      <li>联系我们</li>
    </ul> -->
    <Popover
      style=""
      overlay
       trigger="click"
      @click-overlay="console.log('asdf')"
      v-model="showPopover"
      :offset="[-50, 0]"
    >
      <ul class="coverBox" id="woqunide">
        <li @click="jump(1)">@Rihao</li>
        <li @click="jump(3)">薪酬福利</li>
        <li @click="jump(4)">校园招聘</li>
        <li @click="jump(6)">联系我们</li>
      </ul>
      <template #reference>
        <img
          style="margin: 0.2rem; width: 1rem"
          src="data:image/svg+xml;base64,PHN2ZyBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMzIiIGhlaWdodD0iMzIiPjxwYXRoIGQ9Ik0wIDE4NC4zMmgxNTMuNlY4MS45MkgwdjEwMi40em0zMDcuMi0xMDIuNHYxMDIuNEgxMDI0VjgxLjkySDMwNy4yek0wIDU0Mi43MmgxNTMuNnYtMTAyLjRIMHYxMDIuNHptMzA3LjIgMEgxMDI0di0xMDIuNEgzMDcuMnYxMDIuNHpNMCA5MDEuMTJoMTUzLjZ2LTEwMi40SDB2MTAyLjR6bTMwNy4yIDBIMTAyNHYtMTAyLjRIMzA3LjJ2MTAyLjR6IiBmaWxsPSIjMTI5NmRiIi8+PC9zdmc+"
          alt=""
        />
      </template>
    </Popover>
  </div>
</template>

<script>
import { Popover } from "vant";
export default {
  name: "NavBarM",
  components: {
    Popover,
  },
  props: {
    index: Number,
  },
  data() {
    return {
      actions: [{ text: "选项一" }, { text: "选项二" }, { text: "选项三" }],
      showBox: false,
      showPopover: false,
    };
  },
  methods: {
    onSelect(action) {
      console.log(action);
    },
    jump(index) {
      this.showPopover = false;
      this.$emit("jump", index);
    },
    hidden() {
      if (this.showPopover) {
        this.showPopover = false;
      }
    },
    ccc() {
      this.$refs.ul.show();
    },
  },
};
</script>

<style scoped lang="less">
.top {
  height: 1.4rem;
  .logo {
    margin: 0.2rem;
    width: auto;
    height: 1rem;
  }
}

.markUp {
  width: 0.98rem;
  position: absolute;
  top: 0.3rem;
  right: 0.2rem;
}
.coverBox {
  font-size: 0.44rem;
  z-index: 9999;
  width: 3.5rem;
}

.coverBox li {
  background: rgba(10, 150, 221, 0.856);
  border-bottom: 1px solid #ffffff;
  text-align: center;
  padding: 0.1rem;
  color: #ffffff;
}

.coverBox li:last-child {
  border-bottom: 0 !important;
}
</style>
